import {
  usePathQuery,
  useSyncPathMutation
} from "@pathwright/graphql-client/src/generated"
import get from "lodash/get"
import { useCallback } from "react"
import { usePathwrightClient } from "../../pathwright/PathwrightClient"

const usePath = ({
  pathId,
  cohortId,
  userId,
  forceReload,
  ensureConsistentRead = false,
  skip = false
}) => {
  const client = usePathwrightClient()
  const pathQuery = usePathQuery({
    variables: {
      id: pathId, // optional (either pathId or cohortId required)
      user_id: userId, // optional (can always be missing)
      cohort_id: cohortId // optional (either pathId or cohortId required)
    },
    skip: (!cohortId && !pathId) || skip,
    fetchPolicy: forceReload ? "cache-and-network" : "cache-first",
    // Ensure we reload from the main db and not from the read replica
    // if ensureConsistentRead is true.
    client: ensureConsistentRead ? client._consistentReadClient : client
  })
  const { data, error, loading, refetch } = pathQuery
  const path = get(data, "path")

  const [
    syncPath,
    {
      // loading: syncing // handling syncing state
      error: syncError,
      loading: syncingPath
    }
  ] = useSyncPathMutation({
    variables: {
      id: path?.id
    }
  })

  const handleRefetch = useCallback(async () => {
    if (!loading && cohortId) refetch()
  }, [loading, cohortId, refetch])

  const handleSyncPath = useCallback(async () => {
    if (!syncingPath) {
      await syncPath()
    }
  }, [syncingPath, syncPath])

  const loaded = !loading && !error && !syncError && !!path

  return {
    path,
    error: error || syncError,
    loaded,
    loading,
    syncing: syncingPath,
    syncPath: handleSyncPath,
    refetch: handleRefetch
  }
}

export default usePath
